import { AUTHORIZE_MANAGEMENT_DASHBOARD } from '@/data/actions/modules/general';
import Main from './components/Main.vue';
import Indicators from './components/Indicators.vue';
import Tutorial from './components/Tutorial.vue';

export default [
  {
    path: '/',
    component: Main,
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
  {
    path: '/tutorial',
    component: Tutorial,
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
  {
    path: '/clinical/indicators',
    component: Indicators,
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: AUTHORIZE_MANAGEMENT_DASHBOARD,
    },
  },
];
